/* eslint-disable prettier/prettier */
import GroupService from "../services/GroupService";
import router from "../router";

const getDefaultState = () => ({
  openTab:false,
  group: {
    group_name: "",
    description: "",
    country: "",
    region: "",
    district: "",
    group_trainer: null,
    teachers: [],
    teacher_names: [],
    trainer_name: "",
    active: true,
    start_date: null,
    end_date: null,
    type: "",
  },
  groups: [],
  groupTeachers: [],
});

const groups = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    group_name(state, val) {
      state.group.group_name = val;
    },
    description(state, val) {
      state.group.description = val;
    },
    country(state, val) {
      state.group.country = val;
    },
    region(state, val) {
      state.group.region = val;
    },
    district(state, val) {
      state.group.district = val;
    },
    group_trainer(state, val) {
      state.group.group_trainer = val;
    },
    trainer_name(state, val) {
      state.group.trainer_name = val;
    },
    groupTeachers(state, val) {
      state.groupTeachers = val;
    },
    teachers(state, val) {
      state.group.teachers = val;
    },
    teacher_names(state, val) {
      state.group.teacher_names = val;
    },
    active(state, val) {
      state.group.active = val;
    },
    type(state, val) {
      state.group.type = val;
    },
    start_date(state, val) {
      state.group.start_date = val;
    },
    end_date(state, val) {
      state.group.end_date = val;
    },
    groups(state, val) {
      state.groups = val;
    },
    resetGroups(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async GET_GROUPS(context) {
      let data;
      if (context.rootState.auth.user.admin) {
        const res = await GroupService.fetchGroups();
        data = res.data.results;
      }else if (context.rootState.auth.user.src) {
        const user_uuid = context.rootState.auth.user.uuid;
        const res = await GroupService.fetchClusterGroups(user_uuid);
        data = res.data.results;
      }else if (context.rootState.auth.coordinator.uuid.length > 0) {
        const res = await GroupService.fetchCoordinatorGroups(
          context.rootState.auth.coordinator.uuid
        );
        data = res.data.results;
      } else {
        const res = await GroupService.fetchTrainerGroups(
          context.rootState.auth.trainer.uuid
        );
        data = res.data.results;
      }

      context.commit("groups", data);
    },
    async GET_ALL_GROUPS(context) {
      const res = await GroupService.fetchGroups();
      const data = res.data.results;
      context.commit("groups", data);
    },
    async GET_ONE_GROUP({
      state
    }) {
      const res = await GroupService.getOneGroup(router.currentRoute.params.id);
      const data = res.data.results;
      if (data.length > 0) {
        const groupData = data[0];
        state.group = groupData;
        const teachersIds = [];
        const teachersNames = [];
        data.forEach((element) => {
          if (element.trainer_uuid) {
            state.group.group_trainer = element.trainer_uuid;
            state.group.trainer_name = element.trainer_name;
          }
          if (element.teacher_uuid) {
            teachersIds.push(element.teacher_uuid);
            teachersNames.push(element.teacher_name);
          }
        });
        // console.log(state.group);
        state.group.teachers = teachersIds;
        state.group.teacher_names = teachersNames;
      } else {
        state.group = data;
      }
    },
    async CREATE_GROUP({ state }) {
      const data = {
        ...state.group,
      };
      delete data.id;
      delete data.teacher_names;
      delete data.trainer_name;
      delete data.trainer_uuid;
      delete data.teacher_name;
      delete data.teacher_uuid;

      console.log(data);
      const res = await GroupService.createGroup(data);
      console.log(res);
    },
    async UPDATE_GROUP({ state }) {
      const data = {
        ...state.group,
      };
      delete data.teacher_names;
      delete data.trainer_name;
      delete data.trainer_uuid;
      delete data.teacher_name;
      delete data.teacher_uuid;
      delete data.teachers;
      delete data.group_trainer;
      console.log(data);
      const res = await GroupService.updateGroup(data);
      console.log(res);
    },
    async GET_GROUP_TEACHERS(context) {
      const teachers = await GroupService.fetchTeachers({
        id: router.currentRoute.params.id,
      });
      const data = teachers.data.results;
      context.commit("groupTeachers", data);
    },
    async GET_GROUP_TEACHERS_BY_ID(context,id) {
      const teachers = await GroupService.fetchTeachersByID(id);
      const data = teachers.data.results;
      var tmpNames = [];
      var tmpIds = [];
      data.forEach((e)=>{
        tmpIds.push(e.uuid);
        tmpNames.push(e.first_name+" "+e.last_name);
      });
      context.commit("teacher_names", tmpNames);
      context.commit("teachers", tmpIds);
    },
    ADD_TEACHER: async (state, data) => {
      const res = await GroupService.addTeacher(data.id);
      console.log(res);
    },
    DELETE_TEACHER: async (state, data) => {
      console.log(data.id);
      const res = await GroupService.deleteTeacher(data.id);
      console.log(res);
    },
    DELETE_TEMP_TEACHER: async (state, data) => {
      console.log(data.id);
      const res = await GroupService.deleteTempTeacher(data.id);
      console.log(res);
    },
    ADD_TRAINER: async (state, data) => {
      console.log("adding trainer: ", data.id);
      const res = await GroupService.addTrainer(data.id);
      console.log(res);
    },
    DELETE_TRAINER: async (state, data) => {
      console.log("deleting trainer: ", data.id);
      const res = await GroupService.deleteTrainer(data.id);
      console.log(res);
    },
    async DELETE_GROUP(id) {
      const res = await GroupService.deleteGroup(id);
      console.log(res);
    },
    async RESET_GROUPS_STATE(context) {
      await context.commit("resetGroups");
    },
  },
  getters: {
    groupTeachersObj: (state) => {
      const teachersIds = state.group.teachers;
      const teachersNames = state.group.teacher_names;
      const results = [];
      // eslint-disable-next-line
      for (let i = 0; i < teachersIds.length; i++) {
        const obj = {
          id: teachersIds[i],
          teacher_name: teachersNames[i],
        };
        results.push(obj);
      }
      return results;
    },
    groupTrainer: (state) => {
      const trainerId = state.group.group_trainer;
      const trainerName = state.group.trainer_name;
      const obj = {
        id: trainerId,
        name: trainerName,
      };
      return obj;
    },
  },
};

export default groups;
